import {
  AccessoryProductInfo,
  AuthUser,
  ComboBox,
  ComboBoxItem,
  ContactType,
  Controls,
  GuaranteeType,
  NoticeMessage,
  NoticeTemplate,
  Offer,
  OrderStatusEnum,
  Organization,
  Person,
  PicklistItem,
  ProductSelectionParameters,
  Proposal,
  QcHeader,
  RootState,
  TaskDefinition,
  TaskModule,
  UniformOdmName
} from '@/types';
import * as table_config_import from "@/utils/configuration/table-config";
import * as notify_config_import from "@/utils/configuration/notify-config";
import * as formatters_config_import from "@/utils/configuration/formatters-config";
import { formatDateLocale, getEqualValue, getLikeValue } from "@/utils/configuration/formatters-config";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as input_rules from "@/utils/configuration/input-rules";
import { api, apiAnonymousToken } from "@/auth/api";
import { settings } from "@/settings";
import axios from "axios";
import moment from "moment";
import i18n from "@/i18n";
import { RouteRecordName, Router } from "vue-router";
import router from "@/router";
import store from '@/store';
import Notify from 'quasar/src/plugins/Notify.js';import exportFile from 'quasar/src/utils/export-file.js';;
import { buildGenericInfo, buildOfferControls, buildPartyControls } from '@/store/services/controls/controlsMapper';
import { getProposalInfoScale } from '@/store/services/financing/financingMapper';
import { getAgeEndOfContract, getContractDuration, getFinancedValue, verifyPartyInsured } from '@/store/services/financing/financingService';
import taskModule from '@/store/modules/task/taskModule';
import { SignJWT } from "jose";

// CONSTANTS
const storageKeys = {
  simulationModule: 'simulationModule',
  thirdModule: 'thirdModule',
  demandModule: 'demandModule',
  authModule: 'authModule',
  orderModule: 'orderModule',
  taskModule: 'taskModule',
  orderTask: 'orderTask',
  supersetConfig: 'supersetConfig',
  userNetworkNodes: 'userNetworkNodes',
  logoConfig: 'logoConfig',
  configuration: 'configuration',
  partyUser: 'partyUser',
  userPrefrences: 'userPrefrences',
  orderListFilters: 'eflo_orderListFilters'
}
export const TAXDEFAULT = {
  val: 20
}
export const UON = {
  ObjectType: {
    frenchOrganization: 'odm.party.party.organization.frenchorganization',
    frenchPerson: 'odm.party.party.person.frenchperson',
    offer: 'odm.offer.offer',
    offerInitialization: 'odm.offer.offerinitializationcontext',
    associatedParty: 'odm.offer.associatedparty',
    maritalStatus: 'odm.party.maritalstatus',
    personTitle: 'odm.party.persontitle',
    offerAssociatedParty: 'odm.offer.offerassociatedparty',
    partyAddress: 'odm.party.partyaddress',
    address: 'odm.party.address',
    associatedPartyRole: 'odm.offer.associatedpartyrole',
    associatedGuaranteeUnderlyingAssets: 'odm.offer.associatedguaranteeunderlying.associatedguaranteeunderlyingassets',
    proposalGuarantee: {
      objectType: new Map<string, string>([
        [GuaranteeType.PERSONAL_GUARANTEE, 'odm.offer.proposalguarantee.proposalpersonalguarantee'],
        [GuaranteeType.BANK_GUARANTEE, 'odm.offer.proposalguarantee.proposalbankguarantee'],
        [GuaranteeType.MORTGAGE, 'odm.offer.proposalguarantee.proposalguaranteewithunderlying.proposalmortgageguarantee'],
        [GuaranteeType.PROPERTY_PLEDGING, 'odm.offer.proposalguarantee.proposalguaranteewithunderlying.proposalpropertypledgingguarantee'],
        [GuaranteeType.BUY_BACK, 'odm.offer.proposalguarantee.proposalguaranteewithunderlying.proposalbuybackguarantee']
      ])
    },
    fileManagement: {
      fileContent: "odm.filemngt.filecontent"
    }
  },
  SystemUid: {
    odmUser: 'odm-user',
    odmAuthentication: 'odm-authentication',
    odmEsign: 'odm-esign',
    odmParty: 'odm-party',
    odmOffer: 'odm-offer',
    odmFileManagement: 'odm-filemngt',
    odmProduct: 'odm-product',
    odmDecision: 'odm-decision',
    odmContactMechanism: 'odm-contactmechanism',
    odmAnalysis: 'odm-analysis',
    odmConfiguration: 'odm-configuration',
    odmOrder: 'odm-order',
    odmSupportingDocument: 'odm-supportingdocument',
    odmSimulation: 'odm-simulation',
    odmEsignbridge : 'odm-esignbridge',
    odmOrchestration : 'odm-orchestration'
  }
}

export const PreconditionAction  = [
    "DISTRIBUTIONCTX",
    "DISTRIBUTIONCTX_CDV",
    "DISTRIBUTIONCTX_FAB",
    "DISTRIBUTION_IMMAT",
    "DISTRIBUTION_PREP",
    "DISTRIBUTION_LIV",
    "DISTRIBUTION_POSTLIV",
    "DISTRIBUTION_VC"
];

 export const PreconditionActionGemy  = [
    "DISTRIBUTIONCTX_GEMY",
    "DISTRIBUTION_Appro_GEMY",
   "DISTRIBUTION_DSC_GEMY",
    "DISTRIBUTION_presaisie_gravage_GEMY",
    "DISTRIBUTION_Retard_production_GEMY",
    "DISTRIBUTION_Declenchenment_liv_site_GEMY",
    "DISTRIBUTION_ACC_GEMY",
    "DISTRIBUTION_APLANIFIER_GEMY",
    "DISTRIBUTION_RECEPTIONVEHICULE_GEMY",
    "DISTRIBUTION_CONFIRMATION_RDVCLIENT_GEMY",
    "DISTRIBUTION_PREP_GEMY",
    "DISTRIBUTION_IMMAT_GEMY",
    "DISTRIBUTION_J-2Livraison_GEMY",
    "DISTRIBUTION_LIV_GEMY",
    "DISTRIBUTION_GARANTIE_A_PASSER_GEMY",
    "DISTRIBUTION_Dossier_Red_GEMY",
    "DISTRIBUTION_depot_bonus_GEMY",
    "DISTRIBUTION_BONUS_ECO_GEMY",
    "DISTRIBUTION_DOSSIER_PRET_ARCHIVER_GEMY",
    "DISTRIBUTION_Appro_Annulation_GEMY",
    "DISTRIBUTION_Accessoire_Annulation_GEMY",
    "DISTRIBUTION_RECEPTIONVEHICULE_Annulation_GEMY",
    "DISTRIBUTION_ARCHIVAGE_GEMY"
  ];

export const Paths = {
  team: 'team',
  person: 'person',
  actions: 'actions',
  simpleserviceproduct: 'simpleserviceproduct',
  assetinsuranceproduct: 'assetinsuranceproduct',
  maintenanceproduct: 'maintenanceproduct',
  partyinsuranceproduct: 'partyinsuranceproduct',
  user: 'user',
  frenchOrganization: 'frenchorganization',
  frenchPerson: 'frenchperson',
  frenchProfessional: 'frenchperson',//frenchprofessional
  offer: 'offer',
  associatedParty: 'associatedparty',
  offerAssociatedParty: 'offerassociatedparty',
  partyRelation: 'partyrelation',
  partyAddressPreference: 'partyaddresspreference',
  simpleFinancingOffer: 'simplefinancingoffer',
  financingProductPack: 'financingproductpack',
  simplePackageFeature: 'simplepackagefeature',
  productFeature: 'productfeature',
  financialProfile: 'financialprofile',
  proposalGuarantee: 'proposalguarantee',
  partyContactMechanism: {
    path: 'partycontactmechanism',
    contactMechanism: 'contactmechanism'
  },
  contactMechanism: {
    parentResourceUid: new Map<string, string>([
      [ContactType.EMAIL_CONTACT, 'emailcontact'],
      [ContactType.MESSENGER_CONTACT, 'messengercontact'],
      [ContactType.PHONE_CONTACT, 'phonecontact'],
      [ContactType.POSTAL_MAIL_CONTACT, 'postalmailcontact']
    ])
  },
  productAvailability: 'productavailability',
  subsidyproduct: 'subsidyproduct',
  configuration: {
    controls: 'business-control/validate',
    UiControls: 'uiManagement/screen'
  },
  order: {
    create: `order`,
    get: (resourceUid: string) => `order/${resourceUid}`,
    asset: {
      create: (parentResourceUid: string) => `orderitem/${parentResourceUid}/orderasset`,
      get: (resourceUid: string) => `orderasset/${resourceUid}/`,
      getFromParent: (parentResourceUid: string) => `orderitem/${parentResourceUid}/orderasset`,
    },
    party: {
      create: `orderparty`,
      get: (resourceUid: string) => `orderparty/${resourceUid}`,
    },
    network: {
      create: `ordernetwork`,
      get: (resourceUid: string) => `ordernetwork/${resourceUid}`,
    },
    networkNode: {
      create: `ordernetworknode`,
      get: (resourceUid: string) => `ordernetworknode/${resourceUid}`,
    },
    assetDelivery: {
      create: `orderdeliverydetails`,
      get: (resourceUid: string) => `orderdeliverydetails/${resourceUid}`,
    },
    assetTradeIn: {
      create: `orderassettradein`,
      get: (resourceUid: string) => `orderassettradein/${resourceUid}`,
    },
    financing: {
      create: `orderfinancing`,
      get: (resourceUid: string) => `orderfinancing/${resourceUid}`,
    },
    orderAssociatedParty: {
      create: (parentResourceUid: string) => `order/${parentResourceUid}/orderassociatedparty`,
      get: (resourceUid: string) => `orderassociatedparty/${resourceUid}/`,
      getFromParent: (parentResourceUid: string) => `order/${parentResourceUid}/orderassociatedparty`,
    },
    orderPayPlanObjective: {
      create: `payplanobjective`,
      get: (resourceUid: string) => `payplanobjective/${resourceUid}`,
    },
    orderPayPlan: {
      create: `payplan`,
      get: (resourceUid: string) => `payplan/${resourceUid}`,
    },
    orderPlanning: {
      create: (parentResourceUid: string) => `order/${parentResourceUid}/orderplanning`,
      get: (resourceUid: string) => `orderplanning/${resourceUid}/`,
      getFromParent: (parentResourceUid: string) => `order/${parentResourceUid}/orderplanning`,
      update:(resourceUid: string) => `orderplanning`,
    },
    assignedUser: {
      create: `assigneduser`,
      get: (resourceUid: string) => `assigneduser/${resourceUid}/`,
      update:(resourceUid: string) => `assigneduser/${resourceUid}/`,
    },
  },
  marge:{
    get: (resourceUid: string) => `calculation/margin/${resourceUid}`,
  },
  AbsenceManagement: {
    create: `absence`,
    get: (resourceUid: string) => `absence/${resourceUid}`,
  },
  updateDelegationLevel: "updateDelegationLevel",
  carProduct: "carproduct",
}

export const Masks = {
  dateMask: 'YYYY-MM-DD',
  dateMask_Sys: 'DD/MM/YYYY',
  timestampMask: 'YYYY-MM-DD HH:mm:ss',
  timestampMask_Sys: 'DD/MM/YYYY HH:mm:ss',
  frenchPhoneMask: {
    mask: '(+33)# ## ## ## ##',
    filledmask: '(+33)_ __ __ __ __',
    rule: /^\(\+33\)[1-9]\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/


  },
  frenchPhoneNationalMask: {
    mask: '0# ## ## ## ##',
    filledmask: '0_ __ __ __ __',
    rule: /^(0[1-9]\s\d{2}\s\d{2}\s\d{2}\s\d{2})$/
  },
  regexOpinion: /^STEP_ENTER(?:_[^_]+)?_OPINION$/,
  emailMask: /^[a-zA-Z\d._-]+@[a-zA-Z\d.-]+.[a-zA-Z]{2,4}$/,
  passwordMask: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&+\-=()[\]{}_])[A-Za-z\d@#$!%*?&+\-=()[\]{}_]{8,100}$/,
  currencyOptions: {
    "locale": "de-DE",
    "currency": "EUR",
    "currencyDisplay": "symbol",
    "precision": 2,
    "hideCurrencySymbolOnFocus": true,
    "hideGroupingSeparatorOnFocus": true,
    "hideNegligibleDecimalDigitsOnFocus": true,
    "autoDecimalDigits": false,
    "useGrouping": true,
    "accountingSign": false
  }
}

export const myLocale= {
  days: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
  daysShort: 'dim_lun_mar_mer_jeu_ven_sam'.split('_'),
  months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
  monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
  firstDayOfWeek: 1, // lundi
  format24h: true
}

const currencyMapper = (key: string) => {
  const mapping: any = {
    'EUR': '€'
  }
  return mapping[key] || key
}

// Configurations

export const globalConfig = {
  table_config: table_config_import,
  notify_config: notify_config_import,
  formatters: formatters_config_import,
  input_rules: input_rules,
  storageKeys,
  currencyMapper,
  capitalize: (value: string) =>
    value.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
}
//Module

export const globalModuleConfig = {
  assetModule: 'assetModule',
  selectedAsset: 'selectedAsset'
}

export const mandatoryFiels = {
  assetFileds: ['name', 'reference', 'status.type.value', 'type.type.value']
}

export const mandatoryFielsFilter = {
  filterFileds: ['description', 'color', 'hasPublicAccess', 'numOrder']
}

export const taskVariables = {
  offer: 'offerId;offerStatus;offerReference;customerName;_offerDecisionProcessId;_clientDecisionProcessId;' +
    'associated_networks_id;customerRessourceUid;customerBirthDate;offerCreationDate;associated_network_nodes_id;' +
    'customerType;offerPhase;customerReference;applicationName;analysisProcessId;_decisionAnalysisProcessId',
  order: ''
}

// Functions

export function edit(value: { isDisabled: boolean; }) {
  value.isDisabled = !value.isDisabled;
}

export function add<T>(items: T[], getter: T) {
  items.push(getter);
}

export function remove<T>(index: number, items: T[], condition = items.length > 0) {
  if (items && condition) {
    items.splice(index, 1);
  }
}

export function addExpandedItem<T extends { objectType: string, isDisabled: boolean }>(items: T[], getter: T) {
  if (items && items.length === 0) {
    items.push(getter);
  }
}

export function removeExpandedItem<T extends { isDisabled: boolean }>(items: T[]) {
  if (items && items.length === 1 && items[0].isDisabled) {
    items.splice(0, 1);
  }
}

export function deleteNonRequiredAttributes<T>(clazz: T, requiredAttributes: string[]) {
  Object.keys(clazz).forEach(field => {
    if (!requiredAttributes.includes(field)) {
      const element = clazz as never;
      delete element[field];
    }
  });
}

export function deleteAttributes<T>(clazz: T, attributesToDelete: string[]) {
  Object.keys(clazz).forEach(field => {
    if (attributesToDelete.includes(field)) {
      const element = clazz as never;
      delete element[field];
    }
  });
}

export function deleteAttributesRecursively<T>(clazz: T, attributesToDelete: string[]) {
  Object.entries(clazz).forEach(([key, value]) => {
    if (attributesToDelete.includes(key)) {
      const element = clazz as never;
      delete element[key];
    }
    else if (typeof value === 'object' && value !== null) {
      deleteAttributesRecursively(value, attributesToDelete)
    }
  });
}

export function removeAttributesRecursively<T>(clazz: T) {
  if (clazz) {
    Object.values(clazz).forEach(value => {
      const _controls = (clazz as never)['_controls'] as Controls;
      if (_controls && _controls.attToRemove) {
        _controls.attToRemove.forEach(att => {
          const element = clazz as never;
          delete element[att];
        });
        delete (clazz as never)['_controls'];
      } else if (typeof value === 'object') {
        removeAttributesRecursively(value);
      }
    });
  }
}

export function formatDateRecursively<T>(data: T, inDateMask: string = Masks.dateMask, outDateMask: string = getMaskFormat()) {
  if (data) {
    Object.entries(data).forEach(([key, value]) => {
      if (moment(value, inDateMask, true).isValid()) {
        const element = data as any;
        element[key] = formatDateLocale(value, inDateMask, 'US', outDateMask);
      }
      else if (typeof value === 'object' && value !== null) {
        formatDateRecursively(value, inDateMask, outDateMask);
      }
    });
  }
}

export const deepClone = (object: object) => {
  return JSON.parse(JSON.stringify(object))
}

export const sleep = async (time: number) => {
  return new Promise(resolve => {
    setTimeout(resolve, time)
  })
}

export function mountSelectFields<T>(payload: T, combos: Array<string>) {
  if (payload) {
    Object.entries(payload).forEach(([key, value]) => {
      if (combos.includes(key)) {
        const attribute = payload as any;
        if (attribute[key]) {
          if (!attribute[key].type) {
            attribute[key] = {
              type: {
                value: attribute[key].resourceUid
              }
            }
          }
          else if (!attribute[key].type.value) {
            attribute[key] = {
              type: {
                value: ''
              }
            }
          }
        }
      }
      else if (typeof value === 'object' && value !== null) {
        mountSelectFields(value, combos)
      }
    })
  }
}

export const unmountSelectFieldsV2 = <T>(payload: T, combos: Array<string>) => {
  if (payload) {
    Object.entries(payload).forEach(([key, value]) => {
      if (combos.includes(key)) {
        const attribute = payload as any;
        if (!attribute[key]?.type) {
          console.warn(`attribute ${key} is not a ComboBox`)
        }
        else {
          if (attribute[key].type.value && attribute[key].type.value !== '') {
            attribute[key].resourceUid = attribute[key].type.value
          }
          delete attribute[key].type
        }
      }
      else if (typeof value === 'object') {
        unmountSelectFieldsV2(value, combos)
      }
    })
  }
}

export const unmountSelectFields = <T>(payload: T) => {
  if (payload) {
    Object.entries(payload).forEach(([key, value]) => {
      if (isComboBox(value) && key === 'type') {
        const attribute = payload as any;
        attribute.resourceUid = attribute[key].value
        delete attribute[key]
      }
      else if (typeof value === 'object') {
        unmountSelectFields(value)
      }
    })
  }
}

export const isComboBox = (object: unknown): object is ComboBox => {
  if (object && typeof object === "object") {
    return "value" in object
  }
  return false
}

export const isParty = (object: unknown): object is Person | Organization => {
  if (object && typeof object === "object") {
    return "type" in object;
  }
  return false;
}

export const isPerson = (object: unknown): object is Person => {
  if (object && typeof object === "object") {
    return "familyName" in object;
  }
  return false;
}

export const isOrganization = (object: unknown): object is Organization => {
  if (object && typeof object === "object") {
    return "siren" in object;
  }
  return false;
}

export const isUON = (object: unknown): object is UniformOdmName => {
  if (object && typeof object === "object") {
    return "resourceUid" in object;
  }
  return false;
}

export function getMaskFormat() {
  return i18n.global.t('mask.format')
}

export function getDateTimeMask() {
  return i18n.global.t('mask.dateTime')
}

export function getMaskInput() {
  return i18n.global.t('mask.input')
}
export function wrapCsvValue(val: string, formatFn?: Function, row?: string) {
  let formatted = formatFn !== void 0 ? formatFn(val, row) : val;

  formatted = formatted === void 0 || formatted === null ? "" : String(formatted);

  formatted = formatted.split('"').join('""');

  return `${formatted}`;
}


export function exportToCsv(rows: any , columns: any){
    const content = [columns.map((col:any) => wrapCsvValue(i18n.global.t(col.label))).join(";")]
    .concat(
      rows.map((row:any) =>
        columns
          .map((col: any) =>
            wrapCsvValue(
              typeof col.field === "function"
                ? col.field(row)
                : row[col.field === void 0 ? col.name : col.field],
              col.format,
              row
            )
          )
          .join(";")
      )
    )
    .join("\r\n");

  const status = exportFile("report.csv", '\ufeff'+content, "text/csv");

  if (status !== true) {
    Notify.create({
      message: "Browser denied file download...",
      color: "negative",
      icon: "warning",
    });
  }else{
     Notify.create({
                    message:i18n.global.t('reportScreen.downloadCompletedSuccessfully'),
                    color: "positive",
                  });
  }
}

export function setPicklistResourceUid<T>(clazz: T) {
  if (clazz) {
    Object.values(clazz).forEach(value => {
      if (value.type && value.type?.value) {
        value.resourceUid = value.type?.value;
      }
      else if (typeof value === 'object') {
        setPicklistResourceUid(value);
      }
    });
  }
}

export function copyProperties(source: any, target: any) {
  Object.keys(source).forEach((rowKey) => {
    Object.keys(target).forEach((key) => {
      if (key.toLowerCase() === rowKey.toLowerCase()) {
        if (target[key] && target[key].type) {
          target[key].type.value = source[rowKey];
        }
        else {
          target[key] = source[rowKey];
        }
      }
    })
  })
}

/**
 * This function selects specified attributes from a given object.
 *
 * @param {any} obj - The object to pick attributes from.
 * @param {string[]} attributes - An array of attribute names to pick from the object.
 * @return {Record<string, unknown>} Returns a new object with only the picked attributes.
 */
export const pickAttributes = (obj: any, ...attributes: string[]): Record<string, unknown> => {
  return attributes.reduce((pickedAttributes: Record<string, unknown>, att: string) => {
    if (att in obj) {
      pickedAttributes[att] = obj[att];
    }
    return pickedAttributes;
  }, {});
}

export const chunkList = (array: any[], chunkSize: number) => {
  const result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    result.push(chunk)
  }
  return result
}

export function parseJwt(token: string | null) {
  const base64Url = token?.split('.')[1];
  const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = '';
  if (base64) {
    jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
  return JSON.parse(jsonPayload);
}

export function tokenIsValid() {
  const token = localStorage.getItem('token');
  if (token) {
    const tokenData = parseJwt(token);
    const now = new Date().getTime() / 1000;
    return tokenData.exp > now;
  }
  else {
    return false;
  }
}

export function tokenLocalStorgeIsValid() {
  const token = localStorage.getItem('token');
  if (token) {
    const tokenData = parseJwt(token);
    const now = new Date().getTime() / 1000;
    return tokenData.exp > now;
  }
  else {
    return false;
  }
}

export function initControl(attToRemove = ['isDisabled'], dateFormat = 'yyyy-mm-dd'): Controls {
  return {
    attToRemove, dateFormat
  }
}

export function getOperator(table: string, field: string, operator: string, value?: any, parameter?: string, inParameters?: string[]) {
  return {
    "expression": {
      "table": table,
      "field": field,
      "operator": operator,
      "value": value,
      "parameter": parameter,
      "inValue": (inParameters && inParameters.length > 0) ? {
        "values": inParameters
      } : null,
    }
  }
}



// Rest and session
export const SESSION_TOKEN_KEY = "token";
export const SESSION_TOKEN_ANONYMOUS_KEY = "tokenAnonymous";
export const SELECTED_USER_NETWORK = "selectedUserNetwork";
export const SELECTED_USER_DELEGATION ="selectedUserDelegation"

export function setToken(token: string): void {
  if (localStorage) {
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  }
}

export function getTokenStorage(): string {
  let token = "";
  if (localStorage) {
    const _token = localStorage.getItem(SESSION_TOKEN_KEY);
    token = _token ? _token : token;
  }
  return token;
}

export function cleanSession() {
  if (localStorage) {
    localStorage.removeItem(SESSION_TOKEN_KEY);
  }
}

export function headers(params = {}) {
  const token = localStorage.getItem(SESSION_TOKEN_KEY); 
  if (token) {
    return { Authorization: 'Bearer ' + token, ...params };
  } else {
    router.push('/login')
  }
}

export async function upsert(system_uid: string, body: any, path: string, parentResourceUid?: string, daaqResourceUid?: string): Promise<string> {
  let resourceUid = body.resourceUid
  if (!resourceUid) {
    const url = `/${system_uid}/api/1/${system_uid}/${path}/`;
    if (path === 'emailcontact') {
      body.objectType = "odm.party.contactmechanism.emailcontact"
      deleteAttributes(body, ['identifier', 'phoneNumber', 'acceptSMS'])
    }
    resourceUid = (await api(store?.state?.authModule?.daaqResourceUid).post(url, body)).data.resourceUid
  } else {
    const url = !parentResourceUid
      ? `/${system_uid}/api/1/${system_uid}/${path}/${resourceUid}/`
      : `/${system_uid}/api/1/${system_uid}/${parentResourceUid}/${path}/${resourceUid}/`;
    resourceUid = (await api().put(url, body)).data.resourceUid
  }
  return resourceUid
}
export async function upsertWithDataMessageReturn(system_uid: string, body: any, path: string, parentResourceUid?: string) {
  if (body) {
    const url = `/${system_uid}/api/1/${system_uid}/${path}/`;
    const config = {
      headers: {
        'Content-Length': 0,
        'Content-Type': 'text/plain'
      }
    };
    try {
      return (await api().post(url, body, config)).data
    } catch (e) {
      return {
        message: 'IBAN is incorrect, please verify IBAN'
      }
    }

  }
}

export async function upsertWithDataReturn(system_uid: string, body: any, path: string, parentResourceUid?: string, daaqResourceUid?: string) {
  if (!body.resourceUid) {
    const url = `/${system_uid}/api/1/${system_uid}/${path}/`;
    return (await apiAnonymousToken(daaqResourceUid).post(url, body)).data;
  } else {
    const url = !parentResourceUid
      ? `/${system_uid}/api/1/${system_uid}/${path}/${body.resourceUid}/`
      : `/${system_uid}/api/1/${system_uid}/${parentResourceUid}/${path}/${body.resourceUid}/`;
    return (await apiAnonymousToken().put(url, body)).data;
  }
}
export async function upsertWithDataReturnAnonymous(system_uid: string, body: any, path: string, parentResourceUid?: string, daaqResourceUid?: string) {
  if (!body.resourceUid) {
    const url = `/${system_uid}/api/1/${system_uid}/${path}/`;
    return (await apiAnonymousToken(daaqResourceUid).post(url, body)).data;
  } else {
    const url = !parentResourceUid
      ? `/${system_uid}/api/1/${system_uid}/${path}/${body.resourceUid}/`
      : `/${system_uid}/api/1/${system_uid}/${parentResourceUid}/${path}/${body.resourceUid}/`;
    return (await apiAnonymousToken().put(url, body)).data;
  }
}
export const createOffer = async (payload: any, uri: { systemUid: string, path: string }, daaqResourceUid?: string) => {
  return payload.resourceUid
    ? (await api().put(`/${uri.systemUid}/api/1/${uri.path}${payload.resourceUid}/`, payload)).data
    : (await api(daaqResourceUid).post(`/${uri.systemUid}/api/1/${uri.path}`, payload)).data
}


export async function getEntity(system_uid: string, path: string, resourceUid?: string) {
  const url = `/${system_uid}/api/1/${system_uid}/${path}/${resourceUid}/`;
  return (await api().get(url)).data;
}

export const createUser = async (payload: AuthUser, uri: { systemUid: string, path: string }) => {
  if (payload.daaqList) {
    delete payload.daaqList
  }
  removeAttributesRecursively(payload);
  return axiosAnonymousPostRequest(uri, payload);
}

export const validateCode = async (payload: unknown, uri: { systemUid: string, path: string }) => {
  return axiosAnonymousPostRequest(uri, payload);
}

export const login = async (payload: AuthUser, uri: { systemUid: string, path: string }) => {
  return (await axios.post(`${settings.api_url}/${uri.systemUid}/api/1/${uri.path}`, payload)).data.token;
}

export const loginSSO = async (payload: AuthUser, uri: { systemUid: string, path: string }) => {
  return (await axios.post(`${settings.api_url}/${uri.systemUid}/api/1/${uri.path}`, payload)).data.token;
}

export async function requestForgotPasswordValidationCode(payload: { login?: string }, uri: { systemUid: string, path: string }) {
  return axiosAnonymousPostRequest(uri, payload);
}

export async function resetPassword(payload: { login?: string, smsCode?: string, password?: string }, uri: { systemUid: string, path: string }) {
  return axiosAnonymousPostRequest(uri, payload);
}

async function axiosAnonymousPostRequest(uri: any, payload: any) {
  try {
    const promise = await axios.post(settings.auth_anonymous_api_url)
    return (await axios.post(`${settings.api_url}/${uri.systemUid}/api/1/${uri.path}`, payload, {
      headers: {
        'Authorization': 'Bearer ' + promise.data.token,
      }
    })).data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message?.returnMessage.includes('This user is already created!')
                          ? i18n.global.t("user.errorUserAlreadyCreated")
                          : 'An unexpected error occurred'
    Notify.create({
      message: errorMessage,
      color: 'negative',
    });
    throw new Error(errorMessage);
  }
}

export const groupBy = (xs: any, key: any) => {
  return xs.reduce((rv: any, x: any) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const groupByFn = <T>(arr?: T[], fn?: (item: T) => any) => {
  return arr?.reduce<Record<string, T[]>>((prev, curr) => {
    let groupKey;
    if (fn) {
      groupKey = fn(curr);
    }
    const group = prev[groupKey] || [];
    group.push(curr);
    return { ...prev, [groupKey]: group };
  }, {});
}

export const summingUp = <T>(arr: T[], fn: (item: T) => number | undefined) => {
  return Number(arr.reduce((prev, curr) => {
    return prev + (fn(curr) || 0)
  }, 0));
}

export const nonNullHelper = (item: any, attr: string, callback: any, nullCallback?: any) => {
  if (item[attr]) {
    callback(item)
  } else if (nullCallback) {
    nullCallback()
  }
}

export const mapResourceUid = (item: any) => item.resourceUid

export function parseTaskVariables(variables: any, taskDefinition?: string): any {
  return getTaskModule(variables) !== TaskModule.ORDER ? parseTaskVariablesOffer(variables, taskDefinition) : parseTaskVariablesOrder(variables, taskDefinition)
}

export function getTaskModule(variablesString: string | any) {
  let module = TaskModule.OFFER
  if (typeof variablesString === 'string') {
    const variables = JSON.parse(variablesString)
    if (variables.module?.value) {
      module = variables.module.value === TaskModule.ORDER ? TaskModule.ORDER : TaskModule.OFFER
    }
  } else {
    if (variablesString.module) {
      if (variablesString.module === TaskModule.ORDER || variablesString.module.value === TaskModule.ORDER) {
        module = TaskModule.ORDER
      }
    }
  }
  return module
}

export function parseTaskVariablesOffer(variablesString: string | any, taskDefinition?: string): any {
  const variables = typeof variablesString === 'string' ? JSON.parse(variablesString) : variablesString
  let decisionProcessId = ''
  const msgError = 'Error: Variable not present'
  if ([
    TaskDefinition.ENTER_DECISION,
    TaskDefinition.DELEGATION_LEVEL,
    TaskDefinition.ANALYSIS
  ].includes(taskDefinition as TaskDefinition)) {
    decisionProcessId = variables._offerDecisionProcessId.value
  } else if (taskDefinition === TaskDefinition.ENTER_CUSTOMER_DECISION) {
    decisionProcessId = variables._clientDecisionProcessId.value;
  } else {
    decisionProcessId = msgError
  }

  const associated_networks_id = variables.associated_networks_id?.value || msgError
  const offerReference = variables.offerReference?.value || msgError
  const customerRessourceUid = variables.customerRessourceUid?.value || msgError
  const offerStatus = variables.offerStatus?.value || msgError
  const customerName = variables.customerName?.value || msgError
  const customerBirthDate = variables.customerBirthDate?.value || msgError
  const offerCreationDate = variables.offerCreationDate?.value || msgError
  const associated_network_nodes_id = variables.associated_network_nodes_id?.value || msgError
  const customerType = variables.customerType?.value || msgError
  const offerPhase = variables.offerPhase?.value || msgError
  const customerReference = variables.customerReference?.value || msgError
  const offerId = variables.offerId?.value || msgError
  const applicationName = variables.applicationName?.value || msgError

  const analysisProcessId = variables.analysisProcessId?.value || msgError
  const _decisionAnalysisProcessId = variables._decisionAnalysisProcessId ? variables._decisionAnalysisProcessId.value : null
  const _checkPointsId = variables._checkPointsId ? variables._checkPointsId.value : null

  const offer = variables.offer?.value || msgError
  let accessoryProductInfo = msgError
  let assetInfo = msgError
  let partyInfo = msgError
  let quoteInfo = msgError
  let offerInfo = msgError

  if (variables.offer && variables.offer.value && variables.offer.value.indexOf('{') === 0) {
    const offerParsed = JSON.parse(variables.offer.value)
    accessoryProductInfo = offerParsed.accessoryProductInfo
    assetInfo = offerParsed.assetInfo
    partyInfo = offerParsed.partyInfo
    quoteInfo = offerParsed.quoteInfo
    offerInfo = offerParsed.offerInfo
  }
  const additional_action_items = variables.additional_action_items ? variables.additional_action_items.value : null
  const SignatureMethod = variables.SignatureMethod ? variables.SignatureMethod.value:null
  return {
    module: TaskModule.OFFER,
    associated_networks_id,
    offerReference,
    customerRessourceUid,
    offerStatus,
    customerName,
    customerBirthDate,
    offer,
    offerCreationDate,
    associated_network_nodes_id,
    customerType,
    offerPhase,
    customerReference,
    offerId,
    applicationName,
    accessoryProductInfo,
    assetInfo,
    partyInfo,
    quoteInfo,
    offerInfo,
    decisionProcessId,
    analysisProcessId,
    _decisionAnalysisProcessId,
    _checkPointsId,
    additional_action_items,
    SignatureMethod
  }
}

export function parseTaskVariablesOrder(variablesString: string | any, taskDefinition?: string): any {
  const variables = typeof variablesString === 'string' ? JSON.parse(variablesString) : variablesString
  const isPerson = variables.customerType?.value === 'person';


  return {
    orderId: variables.orderId?.value || variables.orderId,
    module: variables.module?.value || variables.module,
    associated_networks_id: variables.associated_networks_id?.value || variables.associated_networks_id,
    orderStatus: variables.orderStatus?.value || variables.orderStatus,
    orderCreationDate: variables.orderCreationDate?.value || variables.orderCreationDate,
    customerRessourceUid: isPerson ? (variables.customerRessourceUid?.value || variables.customerRessourceUid) : undefined,
    customerName: variables.customerName?.value || variables.customerName,
    customerBirthDate: isPerson ?  (variables.customerBirthDate?.value || variables.customerBirthDate) : undefined,
    associated_network_nodes_id: variables.associated_network_nodes_id?.value || variables.associated_network_nodes_id,
    customerType: variables.customerType?.value || variables.customerType,
    customerReference: variables.customerReference?.value || variables.customerReference,
    orderReference: variables.orderReference?.value || variables.orderReference,
    applicationName: variables.applicationName?.value || variables.applicationName,
    additional_action_items: variables.additional_action_items?.value || variables.additional_action_items,   
    gatheringProcessLength: variables.gatheringProcessLength,
    isFromDocumalys: variables.isFromDocumalys,
    ignoredAssessementContexts: variables.ignoredAssessementContexts || []
  }
}

export function mountNoticeMessageDataInfo(noticeOffer?: Offer): any {

  let party: any
  noticeOffer?.associatedParties!.forEach(function (item) {
    if (item.associatedParty?.role_code === 'CUSTOMER') {
      party = item.associatedParty
    }
  })

  const third: any = (noticeOffer?.associatedParties ? noticeOffer?.associatedParties[0].associatedParty?.third : undefined)

  const proposal: any = noticeOffer?.proposals[0]
  const asset: any = proposal.proposalItems[0].proposalAssets[0]

  const objNotice = {
    reference: noticeOffer?.reference || '',
    associatedNetworkNodesId: noticeOffer?.associatedNetworkNodes?.resourceUid || '',
    firstName: third.firstName || '',
    siren: '',
    postalCode: party.third.person?.addresses.length ? party.third.person.addresses[0].address.postalCode.postalCode || '' : '',
    positionType: party.third.jobs?.length ? party.third.jobs[0].positionType.type.value || '' : '',
    activityId: '',
    financedValue: proposal.proposalItems[0].financedValue ? proposal.proposalItems[0].financedValue.toString() : '',
    proposalItem: '',
    numberOfPaymentTerm: proposal.proposalItems[0].numberOfPaymentTerm ? proposal.proposalItems[0].numberOfPaymentTerm.toString() : '',
    periodBetweenTwoInstallmentsUnit: proposal.proposalItems[0].periodBetween2Installments.duration ? proposal.proposalItems[0].numberOfPaymentTerm.toString() : '',
    proposalItemEndDate: proposal.proposalItems[0].endDate || '',
    firstPaymentWTax: proposal.proposalItems[0].firstPaymentWTax ? proposal.proposalItems[0].firstPaymentWTax.toString() : '',
    partyClass: '',
    decisionReserveCode1: '',
    decisionReserveCode2: '',
    decisionReserveCode3: '',
    decisionReserveCode4: '',
    decisionReserveCode5: '',
    decisionReserveCode6: '',
    decisionProcessStatusCode: '',
    decisionReasonCode: '',
    decisionMakerResourceUid: '',
    opinionMakerResourceUid: '',
    decisionDate: '',
    commercialName: '',
    analysisProcessId: '',
    addressLine1: party.third.person?.addresses.length ? party.third.person.addresses[0].line1 || '' : '',
    street: party.third.person?.addresses.length ? party.third.person.addresses[0].street || '' : '',
    commercialRegister: '',
    assetQuantity: asset.length ? asset.length.toString() : '',
    assetDescription: asset.description || '',
    assetBrand: asset.brand || '',
    assetRange: asset.range || '',
    assetAmountWoTax: asset.amountWoTax.amount ? asset.amountWoTax.amount.toString() : '',
    assetAmountWTax: asset.amountWTax.amount ? asset.amountWoTax.amount.toString() : '',
    assetItemAmountWoTax: ''
  }

  return objNotice
}

export function mountNoticeMessageItems(noticeTemplate?: NoticeTemplate): any {
  const itemsNotifi: any = []
  const arrItem: any = (noticeTemplate?.items ? noticeTemplate?.items : [])
  arrItem.forEach((item: { validity: any; fileName: any; filePath: any; qualification: any; selected: any }) => {
    if (item.selected) {
      const itNotif: any = {
        validity: item.validity,
        fileName: item.fileName,
        filePath: item.filePath,
        qualification: item.qualification,
        selected: item.selected
      }
      itemsNotifi.push(itNotif)
    }
  })

  const itemsNotice: any = []
  itemsNotice.push({
    resourceUid: noticeTemplate?.resourceUid,
    objectType: "odm.contactmechanism.packnoticetemplateinfo",
    systemUid: "odm-contactmechanism",
    businessData: null,
    daaq: null,
    validity: null,
    fileName: noticeTemplate?.fileName,
    filePath: null,
    isPack: (noticeTemplate?.isPack ? noticeTemplate?.isPack : false),
    items: itemsNotifi
  })

  return itemsNotice
}

export function mountNoticeMessage(noticeOffer?: Offer, noticeTemplate?: NoticeTemplate): NoticeMessage {

  const noticeMessage: any = {
    objectType: "odm.contactmechanism.communicationrequest.noticemessage",
    resourceUid: "TWDDistribution",
    systemUid: "odm-contactmechanism",
    clientApplication: {
      resourceUid: "TWDDistribution"
    },
    parameters: {},
    dataInfo: JSON.stringify(mountNoticeMessageDataInfo(noticeOffer)),
    items: mountNoticeMessageItems(noticeTemplate)
  }

  return noticeMessage
}

export const useDate = {
  currDate: moment(new Date()).format('YYYY-MM-DD'),
  sqlFormat: <T>(date: null | string | T | Date = new Date()) => {
    if (!date) return null;
    else return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
  },
  dateLocale: <T>(date: T, inMask: string, inLocale: string, outMask = Masks.dateMask) => {
    return moment(date, inMask, inLocale).format(outMask)
  },
  sysFormat: (date: string) => moment(date).format('DD/MM/YYYY'),
  withPattern: <T>(date: T, pattern: string) => moment(date).format(pattern),
  isPeriodValid(date: string, from: string, until: string) {
    return moment(date).isBetween(
      moment(from), moment(until ?? this.currDate), undefined, '[]'
    )
  },
  getDays: (from: string, until: string) => {
    const start = moment(useDate.sqlFormat(from));
    const end = moment(useDate.sqlFormat(until));
    const duration = moment.duration(end.diff(start));
    return duration.asDays();
  }
}

export const moveElementInArray = <T>(arr: Array<T>, fromIndex: number, toIndex: number): void => {
  const element = arr.splice(fromIndex, 1)[0];
  arr.splice(toIndex, 0, element);
}

export function getOfferFromState(state: RootState, routePath?: RouteRecordName | null | undefined) {
  if (routePath === 'TaskDetail') {
    return state.taskModule.offer;
  }
  if (routePath === 'demand-edit') {
    return state.demandModule.offer;
  }
  if (routePath === 'mo-demand-detail') {
    return state.middleOfficeModule.offer;
  }
}


export function getOrderFromState(state: RootState, routePath?: RouteRecordName | null | undefined) {
  const stateOrder = store.state.taskModule.previousRoute
  if (routePath === 'TaskDetail' && stateOrder) {
    return state.taskModule.order;
  }
  if (routePath === 'order-edit') {
    return state.orderModule.order;
  }
}

/**
 * this function will display success or error after reply or transfer msg
 * @param error
 */
export function notifyReplytransferMsg(error: boolean, context: string) {
  if (error) {
    if (context == "reply") {
      Notify.create({
        message: i18n.global.t(
          "communication.comNotification.messageSent"
        ),
        color: "positive",
      });
    } else {
      Notify.create({
        message: i18n.global.t(
          "communication.comNotification.messageForwarded"
        ),

        color: "positive",
      });
    }
  }
  else {
    if (context == "reply") {
      Notify.create({
        message: i18n.global.t(
          "communication.comNotification.failedMessageSent"
        ),
        color: "negative",
      });
    }
    else {
      Notify.create({
        message: i18n.global.t(
          "communication.comNotification.failedMessageForwarded"
        ),
        color: "negative",
      });
    }
  }
}
/**
 * mapping users and groups to UON objects (recipient = objectType + systemUid + resourceUid uniquement)
 * @param destinations
 */
export function convertToUON(destinations: any[]): any[] {
  return destinations.map((destination) => {
    const objectType = destination.objectType || "odm.user.leaseforgeuser";
    const systemUid = destination.systemUid || "odm-user";
    const resourceUid = destination.resourceUid ?? destination.value;
    return {
      recipient: {
        objectType,
        systemUid,
        resourceUid,
      },
    };
  });
}

export function translateGroupName(UID: any) {
  return i18n.global.t(`middleOffice.decision.profil.${UID}`)
}

export async function getGuarantee(system_uid: string, guaranteeType: string, guaranteeId: string): Promise<string> {
  let guaranteeTypeReformat = ''
  switch (guaranteeType) {
    case 'product-PersonalGuarantee':
      guaranteeTypeReformat = 'personalguarantee';
      break;
    case 'product-BankGuarantee':
      guaranteeTypeReformat = 'bankguarantee';
      break;
    case 'product-Mortgage':
      guaranteeTypeReformat = 'mortgage';
      break;
    case 'product-PropertyPledging':
      guaranteeTypeReformat = 'propertypledging';
      break;
    case 'product-BuyBack':
      guaranteeTypeReformat = 'buyback';
      break;
    default:
      break;
  }
  const url = `/${system_uid}/api/1/${system_uid}/${guaranteeTypeReformat}/${guaranteeId}/`
  const selectedGuarantee = (await api().get(url)).data
  return selectedGuarantee
}
/**
 * orderingByDateTime a list
 */
export const orderingByDateTime = {
  /**
   * in a ascending way
   * @param list
   */
  ascending: <T>(list: T[]) => {
    return list.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime())
  },
  /**
   * in a descending way
   * @param list
   */
  descending: <T>(list: T[]) => {
    return list.sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime())
  }
}

export const ordering = {
  /**
   * Sorts the given list in ascending order based on the specified field.
   * @template T
   * @param {T[]} list - The list to be sorted.
   * @param {string} field - The field to sort the list by.
   * @return {T[]} - The sorted list.
   */
  ascending: <T>(list: T[], field: string): T[] => {
    return list.sort((a: any, b: any) => a[field] - b[field]);
  },

  /**
   * Sorts the given list in descending order based on the specified field.
   * @template T
   * @param {T[]} list - The list to be sorted.
   * @param {string} field - The field to sort the list by.
   * @return {T[]} - The sorted list in descending order.
   */
  descending: <T>(list: T[], field: string): T[] => {
    return list.sort((a: any, b: any) => b[field] - a[field]);
  }
}

/**
 * provides the correct operator to be used in search filters
 * @param params
 */
export const operator = <T>(params: { val: T, table: string, dbField: string }) => {
  const { dbField, val, table } = params;

  /**
   * Validates the input values for `val`, `table`, and `dbField`.
   *
   * @throws {Error} Throws an error if `val` is undefined.
   * @throws {Error} Throws an error if `table` is undefined.
   * @throws {Error} Throws an error if `dbField` is undefined.
   */
  const validate = () => {
    if (!val) throw new Error('field is undefined!')
    if (!table) throw new Error('table is undefined!')
    if (!dbField) throw new Error('dbField is undefined!')
  }
  validate();

  /**
   * Loops through the given field and its nested arrays to add non-array values to the inParams array as strings.
   *
   * @param field - the field to loop through
   * @return {string[]} the array of non-array values converted to strings
   */
  const setInFields = (field: T): string[] => {
    const inParams: string[] = [];

    /**
     * Sets the values of the "inParams" array by recursively traversing the given "field" array.
     *
     * @param field - The array to be traversed and added to "inParams".
     */
    const setInParams = (field: T) => {
      if (Array.isArray(field)) {
        field.forEach((val: T) => {
          if (Array.isArray(val)) {
            setInParams(val);
          } else {
            inParams.push(`'${val}'`);
          }
        });
      }
    }

    setInParams(field);

    return inParams;
  }

  const LIKE = getOperator(
    `lower(${table}`,
    `${dbField})`,
    "LIKE",
    getLikeValue(val).toLowerCase(),
    dbField);

  const EQUAL = getOperator(
    table,
    dbField,
    "EQUAL",
    getEqualValue(val),
    dbField);

  const IN = getOperator(
    table,
    dbField,
    "IN",
    undefined,
    undefined,
    setInFields(val));

  const GREATER_THAN_EQUAL = getOperator(
    table,
    dbField,
    "GREATER_THAN_EQUAL",
    `'${useDate.sqlFormat(val)}'`,
    dbField);

  const LESS_THAN_EQUAL = getOperator(
    table,
    dbField,
    "LESS_THAN_EQUAL",
    `'${useDate.sqlFormat(val)}'`,
    dbField);

  return { LIKE, EQUAL, IN, GREATER_THAN_EQUAL, LESS_THAN_EQUAL };
}

/**
 * mounts the and conditions to be used in the search filter query
 * @param operators
 * @param qc_header
 */
export const setOtherFilters = <T>(operators: T[], qc_header: QcHeader) => {
  if (operators.length > 0) {
    qc_header.qc.otherFilters = {
      expressions: [
        {
          and: {
            operators
          }
        }
      ]
    }
  }
}

/**
 * remove invalid characters from a money value
 * e.g.: 2 349,00 to 2349.00
 * @param money
 */
export const fixMoneyValue = (money = "0") =>
  money.replaceAll(",", ".").replace(/[^0-9.-]+/g, "");

/**
 * translate combobox items
 * @param arr
 * @param i18nKey
 * @returns {ComboBoxItem[]}
 */
export const translateComboBox = ((arr: ComboBoxItem[], i18nKey: string) => {
  const translatedItems = arr.map((item: ComboBoxItem) => ({
    ...item,
    label: i18n.global.t(`${i18nKey}.${item.value}`)
  }));
  translatedItems.sort((a, b) => a.label.localeCompare(b.label));
  return translatedItems;
})
/**
 * translate combobox items
 * @param arr
 * @param i18nKey
 * @returns {PicklistItem[]}
 */
export const translatePicklist = ((arr: PicklistItem[], i18nKey: string) => {
  const translatedItems = arr.map((item: PicklistItem) => ({
    ...item,
    label: i18n.global.t(`${i18nKey}.${item.id}`)
  }));
  translatedItems.sort((a, b) => a.label.localeCompare(b.label));
  return translatedItems;
})



export async function initanalysisData(offerParam: any, dynamicKeys: Record<string, any>) {
  const offer = deepClone(offerParam)
  const proposal = offer.proposals[0]
  const proposalItem = proposal.proposalItems[0]
  const accessoryProductInfo = proposalItem.proposalAccessories
    .map((item: any) => {
      const {
        amountWoTax,
        taxValue,
        basisValue,
        quantity,
        proposalAccessoryCalculationMethodOption,
        proposalAccessoryPaymentDatesOption
      } = item
      return JSON.stringify({
        quantity,
        basis: basisValue,
        currency: amountWoTax.currency,
        paymentDatesOption: proposalAccessoryPaymentDatesOption.resourceUid,
        amount: amountWoTax,
      })
    })

  const assetInfo = proposal.proposalItems
    .map((item: any) => item.proposalAssets)
    .reduce((a: any, b: any) => {
      removeAttributesRecursively(b)
      deleteAttributesRecursively(b, ['isDisabled', 'config'])
      a.push({ assetData: JSON.stringify(deepClone(b)) });
      return a
    }, [])

  const partyInfo = (offer.associatedParties || []).map((offerAssociatedParty: any) => {
    const { role_code } = offerAssociatedParty
    const { third } = offerAssociatedParty.associatedParty
    const type = third.type.id
    const body = type.includes("Organization") ? { ...third.organization } : { ...third.person }
    removeAttributesRecursively(body)
    deleteAttributesRecursively(body, ['isDisabled', 'config'])
    return {
      partyData: JSON.stringify({
        type,
        role: role_code || 'CLIENT',
        ...body
      })
    }
  })

  const quoteInfotemp = deepClone(proposal)
  delete quoteInfotemp.resourceUid
  delete quoteInfotemp.systemUid
  delete quoteInfotemp.objectType
  delete quoteInfotemp.businessData
  delete quoteInfotemp.proposalDecisions


  deleteAttributesRecursively(quoteInfotemp, ['isDisabled', 'config'])
  const accessories = accessoryProductInfo
  const quoteInfo = JSON.stringify(quoteInfotemp)
  const offerObject = {
    quoteInfo,
    partyInfo,
    assetInfo,
    accessories,
    ...dynamicKeys, // Spread the dynamic keys into the object

  };
  return JSON.stringify(offerObject)
}

export const getAnalysesDataRequest = (analysisData: any) => {
  const analysisDataObject = analysisData
  // Add dynamic keys to the object
  const enrichedRequestedData = {
    "analysisData": analysisDataObject,
    "objectType": "",
    "systemUid": "",
    "resourceUid": "",
    "businessData": {},
    "daaq": ""
  }
  return enrichedRequestedData
}

export const generateQuestionsByCategory = (questions: any) => {
  const questionsByCategory: any = {};

  questions.forEach((question: any) => {
    const category = question.question_category_i18n_code;

    if (!questionsByCategory[category]) {
      questionsByCategory[category] = {};
    }

    const questionKey = question.question_i18n_code;

    if (!questionsByCategory[category][questionKey]) {
      questionsByCategory[category][questionKey] = {
        ...question,
        answerOptions: [],
      };
    }

    questionsByCategory[category][questionKey].answerOptions.push({
      answer_option_order: question.answer_option_order,
      answer_option_id: question.answer_option_id,
      answer_option_i18n_code: question.answer_option_i18n_code,
      question_id: question.question_id
    });
  });

  return questionsByCategory;
}

export const generateRatiosByCategory = (ratios: any) => {
  const ratiosByCategory: any = {};

  ratios.forEach((ratio: any) => {
    const category = ratio.category_code;

    if (!ratiosByCategory[category]) {
      ratiosByCategory[category] = {};
    }

    const ratioKey = ratio.ratio_id;

    if (!ratiosByCategory[category][ratioKey]) {
      ratiosByCategory[category][ratioKey] = {
        ...ratio
      };
    }

  });

  return ratiosByCategory;
}


export const convertRatiodataToRatiovalue = (ratios: any) => {
  // Mapper chaque objet "odm.analysis.ratiodata" en "odm.analysis.ratiovalue"
  const convertedRatios = ratios.map((ratiodata: any) => {
    const ratiovalue = {
      ...ratiodata,
      objectType: "odm.analysis.ratiovalue",

    };

    return ratiovalue;
  });

  return convertedRatios;
}



export function checkMandatoryFields(storeLocation: any, mandatoryFields: any) {
  const selectedAsset = storeLocation.reduce((obj: any, key: any) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, store.state);
  const missingFields = mandatoryFields.filter((field: any) => {
    const fieldPath = field.split('.');
    const value = fieldPath.reduce((obj: any, key: any) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, selectedAsset);

    return value === undefined || value === null || value === '';
  });

  return missingFields;
}

/**
 * Generates a random alphanumeric string and returns a substring based on the specified position.
 *
 * @param {number} position - the position to start the substring
 * @return {string} the substring of the generated random alphanumeric string
 */
const getSecureRefSource = (): string => {
  const cryptoApi = globalThis.crypto as Crypto & { randomUUID?: () => string };

  if (typeof cryptoApi?.randomUUID === "function") {
    return cryptoApi.randomUUID().replace(/-/g, "");
  }

  if (cryptoApi?.getRandomValues) {
    const bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }

  return `${Date.now().toString(36)}${performance.now().toString(36).replace(".", "")}`;
}

export const doRef = (position: number): string => getSecureRefSource().substring(position)


export function removeDuplicatesPreferences(preferences: any[]): any[] {
  const uniquePreferences: Set<string> = new Set();
  const newPreferences: any[] = [];

  for (const preference of preferences) {
    const preferenceKey: string = `${preference.preferenceType.resourceUid}-${preference.address.resourceUid}`;

    if (!uniquePreferences.has(preferenceKey)) {
      uniquePreferences.add(preferenceKey);
      newPreferences.push(preference);
    }
  }

  return newPreferences;
}

export async function buildGeneriqueRequestData(stateParam: any, dynamicKeys?:any): Promise<any> {
  const state = deepClone(stateParam)
  const { offer } = state
  const proposalList: Proposal[] = await getProposalInfoScale(store.state)
  const proposal = proposalList[0]
  const assetList = proposal.proposalItems
    .map(item => item.proposalAssets)
    .reduce((a, b) => {
      a.push(deepClone(b));
      return a
    }, [])
  const accessoryProductInfo: AccessoryProductInfo[] = []
  proposal.proposalItems
    .map(item => item.proposalAccessories.forEach(accessories => {
      accessoryProductInfo.push({
        currency: 'EUR',
        quantity: accessories.quantity,
        calculationMethodOption: accessories.proposalAccessoryCalculationMethodOption?.resourceUid,
        paymentDatesOption: accessories.proposalAccessoryPaymentDatesOption?.resourceUid,
        basis: String(accessories.basisValue),
        amount: accessories.amountWoTax,
        annualRate: accessories.rate,
      })
    }))

  const partDirig: any = []
  let partyInfo: any = []
  if (offer && offer.associatedParties) {
    partyInfo = offer.associatedParties
      .sort((offerAssociatedParty: any) => offerAssociatedParty.associatedParty.role_code === 'CUSTOMER' ? -1 : 0)
      .map((offerAssociatedParty: any) => {
        const { role_code } = offerAssociatedParty
        const { third } = offerAssociatedParty.associatedParty
        const type = third.type.id
        const body = type.includes("Organization") ? { ...third.organization } : { ...third.person }
        removeAttributesRecursively(body)
        deleteAttributesRecursively(body, ['isDisabled'])
        body.ageEndOfContract = getAgeEndOfContract(proposal.proposalItems[0], partyInfo)
        if (!type.includes("Organization")) {
          body.birthDate = body.birthDate || moment().format(Masks.dateMask)
        } else if (body.manager != undefined) {
          partDirig.push(body.manager)
        }
        body.flagInsured = verifyPartyInsured(offerAssociatedParty)
        return {
          partyData: JSON.stringify({
            type,
            role: role_code || 'CLIENT',
            ...body
          })
        }
      })


    if (partDirig.length > 0) {
      partyInfo.push({
        partyData: JSON.stringify({
          type: 'party-FrenchPerson',
          role: partDirig[0].roles[0].role.resourceUid,
          flagInsured: true,
          ...partDirig[0]
        })
      })
    }
  }
  const assetInfo = assetList.map(asset => {
    removeAttributesRecursively(asset)
    return {
      assetData: JSON.stringify(asset)
    }
  })
  removeAttributesRecursively(proposal)

  proposal.proposalItems.forEach((el: any) => {
    for (const key in el) {
      if (el[key] === undefined) {
        el[key] = null
      }
    }
    el.contractDuration = getContractDuration(el)
    el.ageEndOfContract = getAgeEndOfContract(el, partyInfo)
    el.financedValue = getFinancedValue(el, state)
  })
  const quoteInfo = JSON.stringify(proposal)
  return {
    partyInfo,
    assetInfo,
    accessoryProductInfo,
    quoteInfo,
  }
}



// This function builds the request object based on the current route and dynamic keys
export async function buildRequestedData(currentRoute: any, dynamicKeys: Record<string, any>) {
  let requestObject: any;
  // Determine the context module based on the current route
  let result;
  if (currentRoute) {
    if (currentRoute._value.path.includes("/mo/")) {
     
      const data = await buildGeneriqueRequestData(store.state.middleOfficeModule, dynamicKeys)
      result = data
      console.log("res---------------", result)
    }
    else if (currentRoute._value.path.includes("/demand/edit")) {
      let data;
      if (dynamicKeys.operation === "insert") {
        data = await buildGenericInfo(store.state.demandModule.offer?.associatedParties![0].associatedParty)
      }
      else {
         data = await buildGeneriqueRequestData(store.state.demandModule, dynamicKeys)
      }
      
      result = data
      console.log("res---------------",result)
    }
    else if (currentRoute._value.path.includes("/task/detail")) {
     
      const data = await buildGeneriqueRequestData(store.state.taskModule, dynamicKeys)
      result = data

    }

    else if (currentRoute._value.path.includes("/third/edit")) {
      const data = await buildPartyControls(store.state)
      const quoteInfo = JSON.parse(data.data.quoteInfo)
      result = {
        ...data.data,
        quoteInfo: quoteInfo
      }
      console.log("res---------------", result)
    }
    requestObject = {
      ...result,
      ...dynamicKeys, // Spread the dynamic keys into the object
    };
    console.log("requestObject : ", requestObject);
  }
  return requestObject;
}

export function updateMandatoryFieldsElements(elem: any, mandatoryFields: any) {
  const element = document.getElementById(elem.componentId);
  element?.classList.add('tw-evaluated-mandatory-error')
  store.dispatch('controlsModule/setBlockedMandatoryFields', mandatoryFields);
  store.state.controlsModule.blockedMandatoryFields.push(elem)
 
}
// This function check the status of mandatory Fields before any Update event
export function ValidateMandatoryFields() {

  const state = store.state.controlsModule.UiStatus;
  let mandatoryFields:any = []

  const UiStatus = state ? state.filter((item: any) => item.mandatoryFlag === true) : []

  UiStatus.forEach((elem: any) => {
    const element = document.getElementById(elem.componentId);
    if (element && element!.getElementsByTagName('input').length > 0) {
      const inputType = element!.getElementsByTagName('input')[0].getAttribute('type')
      if (inputType) {
        switch (inputType) {
          case "text":
            element!.getElementsByTagName('input')[0].value === '' ?
              updateMandatoryFieldsElements(elem, mandatoryFields) : (element?.classList.remove('tw-evaluated-mandatory-error'), store.state.controlsModule.blockedMandatoryFields.splice(store.state.controlsModule.blockedMandatoryFields.indexOf(elem),1));
          break;
          case "checkbox":
            element!.getElementsByClassName('.q-toggle')[0].getAttribute('aria-checked') === "false" ?
              updateMandatoryFieldsElements(elem, mandatoryFields) : (element?.classList.remove('tw-evaluated-mandatory-error'), store.state.controlsModule.blockedMandatoryFields.splice(store.state.controlsModule.blockedMandatoryFields.indexOf(elem), 1));
            break;
        
          default:
            break;
        }
      }
      else {
        const roleType = element!.getElementsByTagName('input')[0].getAttribute('role')
        if (roleType) {
          element!.querySelector('.q-field__native')?.getElementsByTagName('span')[0].innerText === '' ?
            updateMandatoryFieldsElements(elem, mandatoryFields) : (element?.classList.remove('tw-evaluated-mandatory-error'), store.state.controlsModule.blockedMandatoryFields.splice(store.state.controlsModule.blockedMandatoryFields.indexOf(elem), 1));
        }
      }
    }
  });
  return store.state.controlsModule.blockedMandatoryFields.length !== 0 ? false : true
}
export const addedBySystem = ["System","Systéme"];



// This function adds classes to HTML components based on provided flags
export function addClassesToComponent(componentList: any): void {
  componentList.forEach((component: any) => {
    const element: HTMLElement | null = document.getElementById(component.componentId);

    if (element) {
      // Add classes based on component flags
      if (component.disabledFlag) {
        element.classList.add('tw-evaluated-disabled');
      }
      if (component.hiddenFlag) {
        element.classList.add('tw-evaluated-hidden');
      }
      if (component.mandatoryFlag) {
        element.classList.add('tw-evaluated-mandatory');
      }
    } else {
      console.error(`Element with ID ${component.componentId} not found.`);
    }
  });
}

// This function evaluates UI controls based on screen ID, operation, and router
export function evaluateUiControls(screenId: string, operation: string, router: Router, callAPI: boolean) {
  // Dispatch an action to evaluate UI controls
  store.dispatch('controlsModule/evaluateUiControls', {
    screenId: screenId,
    operation: operation,
    router: router,
    callAPI: callAPI,
    callback: (response: any) => {


      // Add classes to components based on the response
      addClassesToComponent(response);
     
      if (store.state.controlsModule.blockedMandatoryFields.length !== 0) {
        ValidateMandatoryFields()
      }
    }
  });
  if (callAPI)
  console.log("UI Evaluation CREATED in : ",screenId);
else console.log("UI Evaluation  UPDATED in :",screenId)

}

export function handleUpdateEvent(screenId : string,operation:string,router: any) {
  evaluateUiControls(screenId, operation, router, false);
}

export function validateContents() {

  const tabs = document.getElementsByClassName('q-tab')
  Array.from(tabs).forEach((tab: any) => tab.click());
  (tabs[0] as HTMLElement).click()
}

//Send Document

export async function SendAllDocuments() {
  const currentRoute = router.currentRoute.value.name;
  const templates = store.state.printDocumentModule.templates
  const selectedTemplates = (templates || []).filter((item) => item.selected)
  await store.dispatch("printDocumentModule/sendTemplate", {
    template: selectedTemplates,
  })
}

// DownloadFiles
export function DownloadAllDocuments() {
  const currentRoute = router.currentRoute.value.name;
  const templates = store.state.printDocumentModule.templates
  const selectedTemplates = (templates || []).filter((item) => item.selected)
  store.dispatch('printDocumentModule/generateDocument', {
    currentRoute: currentRoute,
    templatesSelected: selectedTemplates,
    callback: downloadFile
  })
}

export function downloadFile() {
 const fileId = store.state.printDocumentModule.fileDetailFileId
  store.dispatch("printDocumentModule/downloadFile", {
    request: {
      resourceUid:fileId
    },
    callback: downloadDocumentResponse,
  });
}

export function downloadDocumentResponse(response: any) {
  if (response) {
    const { content } = response;
    const linkSource = `data:${response.format};base64,${content}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = response.originalFileName;
    downloadLink.click();
    store.dispatch('taskModule/setShowLoadingDownload',false)
  }
}

/**
 * Checks if the current user has all of the specified roles.
 * @param {Array} roles - An array of role names to check.
 * @returns {boolean} - Returns true if the user has all roles, otherwise false.
 */
export function checkUserByRole(roles: any) {
  return roles.every((role: any) => store.state.authModule?.user.authorities?.some((authority: any) => authority.authority === role));
}


// Sorts an array of objects by their label property, handling both numeric and string labels.
export const sortItemsByLabel = (items: any[]) => {
  return items.sort((a, b) => {
    const labelA = a.label;
    const labelB = b.label;

    const isNumericA = !isNaN(Number(labelA));
    const isNumericB = !isNaN(Number(labelB));

    if (isNumericA && isNumericB) {
      return Number(labelA) - Number(labelB);
    } else if (isNumericA) {
      return -1;
    } else if (isNumericB) {
      return 1;
    } else {
      return labelA.localeCompare(labelB);
    }
  });
};

export function spliceObjectByKey<T extends Record<string, any>>(obj: T, keyToSplice: keyof T): T {
  const keys = Object.keys(obj) as Array<keyof T>;
  const keyIndex = keys.indexOf(keyToSplice);

  if (keyIndex === -1) {
    // If key not found, return the original object
    return obj;
  }

  // Create a new object by removing the specified key
  const result = { ...obj };
  delete result[keyToSplice];

  return result;
}

export const onSessionExpired = () => {
  store.dispatch("authModule/signOut", {
    callback: () => {
      Notify.create({
        message: i18n.global.t(`main.sessionExpired.message`),
        color: "negative",
        timeout: 20000
      });
    },
  });
};

let isTracking = false;

export const trackJWTStatus = () => {
  if (isTracking) return;
  isTracking = true;

  let hiddenTimerRef: ReturnType<typeof setTimeout> | null = null;
  let wasAwayTooLongRef = false;

  document.addEventListener("visibilitychange", () => {
    const isHidden = document.visibilityState === "hidden";

    if (isHidden) {
      hiddenTimerRef = setTimeout(() => {
        wasAwayTooLongRef = true;
      }, 10 * 1000); // 10 seconds
    } else {
      if (hiddenTimerRef) {
        clearTimeout(hiddenTimerRef);
        hiddenTimerRef = null;
      }

      if (wasAwayTooLongRef && localStorage.getItem('token') && !tokenLocalStorgeIsValid()) {
        onSessionExpired();
        wasAwayTooLongRef = false;
      }
    }
  });
};

export async function createJWTToken(key: string, scope: string, aud: string) {
  const secret = new TextEncoder().encode(key);
	const now = Math.floor(Date.now() / 1000) - 30;
  return await new SignJWT({ scope, iss: 'eflo-disrib', aud })
		.setProtectedHeader({ alg: 'HS256' })
		.setIssuedAt(now)
		.setExpirationTime(now + 60 * 5)
		.sign(secret);
}

export const patternRegexForCommission = /\((.+?)\)\s*\*\s*[\d.]+\s*<\s*[\d.]+\s*\?\s*[\d.]+\s*:\s*\(\(\1\)\s*\*\s*[\d.]+\s*>\s*[\d.]+\s*\?\s*[\d.]+\s*:\s*\(\1\)\s*\*\s*[\d.]+\s*\+\s*[\d.]+\s*\)/;

export function checkMatchedRegexPattern(expression: any) {
  const patternRegex = patternRegexForCommission;

  return patternRegex.test(expression);
}

export function getConfigurationEnv() {
  const configuration = store.state?.orderModule?.order?.orderNetworks?.network?.resourceUid?.id;
  const env = configuration === 'PEUGEOT' ? 'GEMY' : 'BODEMER';
  return env;
}

export function connectedUserconfigurationEnv () {
    let configFromLocalStorage : any = undefined
    const userNetworkNodes = localStorage.getItem(globalConfig.storageKeys.userNetworkNodes)
        if (userNetworkNodes && userNetworkNodes !== 'undefined') {
          configFromLocalStorage = JSON.parse(userNetworkNodes)?.selectedUserNetwork?.config?.network_id
        }
    const configFromStore = store.state.authModule?.selectedUserNetwork?.config?.network_id
    const configuration = configFromStore || configFromLocalStorage
    const env = configuration === 'PEUGEOT' ? 'GEMY' : 'BODEMER';
  return env;
}

export function getStepFromStatus(internalCode: string, flagNew: boolean): number {
  const enumValues = Object.values(OrderStatusEnum);
  const index = enumValues.indexOf(internalCode as OrderStatusEnum);
  if (!flagNew && index > enumValues.indexOf(OrderStatusEnum.MANUFACTURING)) {
    return index;
  }
  
  return index !== -1 ? index+1 : 1;
}

// Formulaire BDC : défini dans un module feuille pour éviter un cycle d'imports
// (bdcPdfExtractor l'évalue au chargement). Ré-exporté ici pour compatibilité.
export { getDefaultForm } from '@/utils/bdcForm';
export type { SupplementForm } from '@/utils/bdcForm';
